import { useCallback, useEffect, useState } from 'react';
import { priceProposalsApi } from '@/features/smart-pricing/services/price-proposals-api';

/** Cada cuánto se refresca solo, en milisegundos (como los de Trade). */
const REFRESH_MS = 5 * 60 * 1000;

const EVENTO = 'prixia:pendientes-de-decidir';

/**
 * Revisar precios ya contó (al aprobar, descartar o deshacer): el menú toma ese
 * número en el momento, sin esperar a que cambie la ruta.
 */
export function avisarPendientesDeDecidir(pendientes: number): void {
  window.dispatchEvent(new CustomEvent<number>(EVENTO, { detail: pendientes }));
}

/**
 * El contador de Compite › Decisiones en el menú lateral («Decisiones 12»,
 * como la maqueta): cuántos precios esperan una decisión. Lo accionable se ve
 * sin entrar.
 *
 * - Falla en silencio: sin permiso o sin red, el menú va sin contador. Un
 *   contador roto no puede romper la navegación.
 * - Se vuelve a pedir cuando cambia `clave` (la ruta), y toma al instante lo
 *   que cuenta Revisar precios al aprobar, descartar o deshacer
 *   (`avisarPendientesDeDecidir`).
 * - Sin el módulo no pide nada (no hay 403 en la consola de nadie).
 */
export function usePendientesDeDecidir(habilitado: boolean, clave: string): number {
  const [pendientes, setPendientes] = useState(0);

  const cargar = useCallback(async () => {
    try {
      const c = await priceProposalsApi.contar();
      setPendientes(c.PENDING ?? 0);
    } catch {
      setPendientes(0);
    }
  }, []);

  useEffect(() => {
    if (!habilitado) {
      setPendientes(0);
      return;
    }
    void cargar();
    const timer = setInterval(() => void cargar(), REFRESH_MS);
    const alAvisar = (e: Event) => {
      const n = (e as CustomEvent<number>).detail;
      if (typeof n === 'number') setPendientes(n);
    };
    window.addEventListener(EVENTO, alAvisar);
    return () => {
      clearInterval(timer);
      window.removeEventListener(EVENTO, alAvisar);
    };
  }, [habilitado, clave, cargar]);

  return pendientes;
}
